import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames/bind'

import TextLink from 'components/text_link/text_link'
import PickerSearchError from '../error/picker_search_error'
import PickerSearchNoResults from '../no_results/picker_search_no_results'

import YoutubeIcon from 'assets/components/nearpod_picker/youtube-icon.svg'

import styles from './video_picker_search.scss'

const cx = classNames.bind(styles)

class VideoSearch extends PureComponent {

	constructor() {
		super()
		this.onKeyPress = this.onKeyPress.bind(this)
		this.onSearchConfirm = this.onSearchConfirm.bind(this)
		this.onNextPageRequest = this.onNextPageRequest.bind(this)
		this.onSearchChange = this.onSearchChange.bind(this)
		this.onSearchSelection = this.onSearchSelection.bind(this)
	}

	onKeyPress(target) {
		if (target.charCode === 13) {
			this.onSearchConfirm()
		}
	}

	onSearchConfirm() {
		this.props.onSearchConfirm('video', this.props.source)
	}

	onNextPageRequest() {
		this.props.onNextPageRequest('video', this.props.source)
	}

	onSearchChange(event) {
		this.props.onSearchChange(event, 'video')
	}

	onSearchSelection(index) {
		this.props.onSearchSelection(index, 'video')
	}

	videoSearchElements() {
		if (this.props.results) {
			return (
				<ul styleName='video-results-list'>
					{
						this.props.results.map((file, index) => (
							<li
								className={cx(
									{ 'video-results-list-item': true },
									{ 'video-results-list-item--selected': this.props.selected.includes(index) }
								)}
								key={index}
								onClick={() => {
									this.onSearchSelection(index)
								}}
							>
								<div className={styles['video-results-list-item-thumbnail']}>
									{ this.props.selected.includes(index) &&
										<iframe draggable='false' src={file.link} frameBorder='0' allowFullScreen className={styles['video-results-list-item-thumbnail-iframe']}></iframe>
									}
									{ !this.props.selected.includes(index) &&
										<img className={styles['video-results-list-item-thumbnail-image']} src={file.thumbnail} alt='' />
									}
								</div>
								<div className={styles['video-results-list-item-info']}>
									<p className={styles['video-results-list-item-info-title']}>{file.title}</p>
									<p className={styles['video-results-list-item-info-desc']}>{file.description}</p>
									<span className={styles['video-results-list-item-info-date']}>{file.date}</span>
								</div>
							</li>
						))
					}
					{this.props.showMore &&
					<TextLink onClick={this.onNextPageRequest}>show more</TextLink>
					}
				</ul>
			)
		} else {
			return null
		}
	}

	render() {
		return (
			<div styleName={classNames({
				'search-video': true,
			})}>
				<div styleName={classNames({
					search: true,
					'search--disabled': false,
				})}>
					<div styleName='search-icon'>
						<div styleName='search-icon-video'>
							<img src={YoutubeIcon} alt='YouTube' />
						</div>
					</div>
					<input
						styleName='search-input'
						type='text'
						placeholder={this.props.placeholder}
						onChange={this.onSearchChange}
						value={this.props.searchTextValue}
						onKeyPress={this.onKeyPress}/>
					<div styleName='search-btn' onClick={this.onSearchConfirm}>
						<svg height="20" width="20" viewBox="0 0 20 20"><path styleName='color-change' d="M18.79 18.46l-6.35-6.35c1.1-1.18 1.78-2.76 1.78-4.5C14.22 3.97 11.26 1 7.61 1 3.97 1 1 3.97 1 7.61c0 3.65 2.97 6.61 6.61 6.61 1.68 0 3.21-.63 4.38-1.67l6.36 6.36c.06.06.14.09.22.09.08 0 .16-.03.22-.09.13-.13.13-.33 0-.45zM7.61 13.59c-3.3 0-5.98-2.68-5.98-5.98 0-3.3 2.68-5.98 5.98-5.98 3.3 0 5.98 2.68 5.98 5.98 0 3.3-2.68 5.98-5.98 5.98zm0 0" fill="#8b9195" stroke="#8b9195" strokeLinecap="round"/></svg>
					</div>
					<p styleName='search-disabled-text'>This feature is only available for Gold or School users</p>
				</div>
				{this.props.active &&
				<div styleName='results'>
					{ this.props.results.length > 0 &&
						this.videoSearchElements()
					}
					{ this.props.hint &&
						<PickerSearchError hint={this.props.hint} />
					}
					{ this.props.message &&
						<PickerSearchNoResults />
					}
				</div>
				}
			</div>
		)
	}
}

export default CSSModules(VideoSearch, styles, {allowMultiple: true})
